import { Card } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

export function TermsOfUseView() {
	return (
		<Card style={{ width: 'auto', margin: 5 }} title={<FormattedMessage id="terms_of_use_title" />}>
			<ul>
				<li>
					<Link
						to={`${process.env.PUBLIC_URL}/legal/terms`}
						target="_blank"
						rel="noopener noreferrer"
					>
						<FormattedMessage id="terms_of_use_conditions" />
					</Link>
				</li>
				<li>
					<Link
						to={`${process.env.PUBLIC_URL}/legal/privacy`}
						target="_blank"
						rel="noopener noreferrer"
					>
						<FormattedMessage id="terms_of_use_secure" />
					</Link>
				</li>
			</ul>
		</Card>
	);
}
